import React, { CSSProperties, ReactNode, useRef, MouseEventHandler, useEffect, useState } from "react";

import { TooltipPositionType } from "primereact/tooltip/tooltipoptions";
import { GtTooltip, TooltipContentType } from "./gt-tooltip";

interface GtTooltipHOCProps {
    children: ReactNode;
    tooltipContent: TooltipContentType;
    placement?: TooltipPositionType;
    style?: CSSProperties;
    className?: string;
    disableTranslation?: boolean;
    onClick?: MouseEventHandler<HTMLDivElement>;
}

export const TooltipHOC = ({
    children,
    tooltipContent,
    placement,
    style = {},
    onClick = undefined,
    className = "",
    disableTranslation = false,
}: GtTooltipHOCProps) => {
    if (tooltipContent === undefined) return <>{children}</>;

    const [isRef, setIsRef] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setIsRef(true);
    }, []);

    return (
        <>
            <div className={className} onClick={onClick} ref={ref}>
                {children}
            </div>
            {(tooltipContent !== undefined || tooltipContent !== null) && (
                <GtTooltip targetRef={ref} tooltipContent={tooltipContent} placement={placement} disableTranslation={disableTranslation} />
            )}
        </>
    );
};
